'use client'

// A job's pictures, one at a time, swiped or stepped through (Sam, 31 Oct: "this one has 2 and it's good because one is
// out of focus...so we should show both in a tiny carousel"). A strip that snaps a picture at a time, with dots, and
// arrows for a mouse. Each picture is shown whole: they come in tall and wide.

import { useRef, useState } from 'react'
import { look } from './look'

const arrow = { position: 'absolute', top: '50%', transform: 'translateY(-50%)', width: 26, height: 26, borderRadius: 13, border: 'none', background: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: 15, lineHeight: '26px', cursor: 'pointer', padding: 0 }

export function Pics({ urls = [], alt = '', ratio = '1 / 1', border = false }) {
  const strip = useRef(null)
  const [at, setAt] = useState(0)
  const list = urls.filter(Boolean)
  if (!list.length) return null
  const go = (i) => { const el = strip.current; if (el) el.scrollTo({ left: Math.max(0, Math.min(list.length - 1, i)) * el.clientWidth, behavior: 'smooth' }) }
  return (
    <div style={{ position: 'relative', border: border ? `2px solid ${look.ink}` : 'none' }}>
      <div
        ref={strip}
        onScroll={(e) => setAt(Math.round(e.currentTarget.scrollLeft / Math.max(1, e.currentTarget.clientWidth)))}
        style={{ display: 'flex', overflowX: 'auto', scrollSnapType: 'x mandatory', scrollbarWidth: 'none', background: '#1d1d1d' }}
      >
        {list.map((u, i) => (
          // eslint-disable-next-line @next/next/no-img-element
          <img key={u} src={u} alt={list.length > 1 ? `${alt} (${i + 1} of ${list.length})` : alt} loading="lazy" style={{ flex: '0 0 100%', width: '100%', aspectRatio: ratio, objectFit: 'contain', scrollSnapAlign: 'start', display: 'block' }} />
        ))}
      </div>
      {list.length > 1 && (
        <>
          {at > 0 && <button type="button" aria-label="Previous picture" onClick={() => go(at - 1)} style={{ ...arrow, left: 6 }}>‹</button>}
          {at < list.length - 1 && <button type="button" aria-label="Next picture" onClick={() => go(at + 1)} style={{ ...arrow, right: 6 }}>›</button>}
          <div style={{ position: 'absolute', bottom: 6, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: 5, pointerEvents: 'none' }}>
            {list.map((u, i) => <span key={u} style={{ width: 6, height: 6, borderRadius: 3, background: i === at ? '#fff' : 'rgba(255,255,255,0.45)' }} />)}
          </div>
        </>
      )}
    </div>
  )
}

export default Pics
